import { motion } from 'framer-motion';
import Spinner from '@/components/ui/Spinner';

interface OnDarkButtonProps {
  label: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export default function OnDarkButton({
  label,
  onClick,
  loading,
  disabled,
}: OnDarkButtonProps) {
  const isDisabled = loading || disabled;
  return (
    <motion.button
      whileTap={!isDisabled ? { scale: 0.97 } : undefined}
      onClick={onClick}
      disabled={isDisabled}
      className={`inline-flex items-center justify-center gap-2 w-full rounded-xl bg-white text-primary-dark font-sans font-semibold text-base py-3.5 px-6 shadow-md transition-colors cursor-pointer ${
        isDisabled ? 'opacity-60 cursor-not-allowed' : 'hover:bg-white/95'
      }`}
    >
      {loading ? <Spinner /> : label}
    </motion.button>
  );
}
